import { useContext } from "react";
import Flex from "../../../components/Flex"

import "./layout.scss";
import { MenuContext } from "../../../contexts/MenuContext";
import Icons from "../../../components/Icons";
import { Location} from "react-router-dom";
import useNav from "../../../components/useNav";
import datasource from "../../../datasource";
import { spacing } from "../styles";

interface MenuItemType {
    idx: number
    title: string
    path: string
    children?: MenuItemType[]
}

const menuData:MenuItemType[] = datasource.menuData
const portal = datasource.portal

export default () => {

    return (
        <Flex className="layout__header-box" align="center" justify="center">
            <Flex className="layout__header" justify="center" align="center">
                <Menu></Menu>
            </Flex>
            <Logo/>
            <PortalCta/>
        </Flex>
    )
}

const Logo = () => {

    const {nav} = useNav();

    return (
        <Flex className="layout__header__logo" align="center">
            <Icons.Logo onClick={() => nav("/")}></Icons.Logo>
        </Flex>
    )
}

const PortalCta = () => {

    return (
        <Flex className="layout__header__cta" align="center">
            <a
                className="layout__header__cta__link"
                href={portal.link}
                target="_blank"
                rel="noopener noreferrer"
            >
                <Flex gap={spacing("md")} reposive={false} align="center">
                    {portal.label}
                    <Icons.ArrowUp width={16} height={16}></Icons.ArrowUp>
                </Flex>
            </a>
        </Flex>
    )
}

const Menu = () => {
    return (
        <Flex gap={40} align="center">
            {
                menuData.map(it => <MenuItem item={it}></MenuItem>)
            }
        </Flex>
    )
}

const MenuItem = (props: {item: MenuItemType}) => {

    const {
        item
    } = props
    const {current, setCurrent} = useContext(MenuContext)
    const {nav} = useNav();

    const doClick = () => {
        setCurrent([item.idx])
        nav(item.path)
    }

    return (
        <div
            className={["menu__item", current[0] == item.idx?"menu__item_activate":""].join(" ")}
            onClick={doClick}
        >
            {item.title}
        </div>
    )
}


export function calCurrentMenu(location: Location){

    const path = location.pathname
    switch(path){
        case "/products":
        case "/translation-service":
        case "/webhosting-service":
        case "/products/aaolens":
            return [1]
        case "/careers":
            return [2]
        default:
            return [0]

    }

}